module.exports = __webpack_public_path__ + "img/car_active.c408e637.svg";